import React from 'react';
import { useTranslation, useUserInfoStore } from '@pascal/pascal-core';
import { allChipsTotal } from '../../helpers/chipsTotal';

export const AutoBetHeader = ({ setIsShowBetActionModal, autoBetModel }) => {
  const t = useTranslation();
  const { currencySymbolOrCode } = useUserInfoStore();
  const allChipsTotalAmount = autoBetModel ? allChipsTotal(autoBetModel.betModel) : 0;
  return (
    <div className='r-auto-bet-inner-header'>
      <div className='r-a-p-header-inner'>
        <div className='r-close-btn' onClick={() => setIsShowBetActionModal(false)}>
          <i className='icon-close' />
        </div>
        <div className='r-a-p-heading'>
          {`${ t('AUTO_BET')}: `}
          <p className='r-a-p-heading-text'>
             {autoBetModel ? autoBetModel.autoBetCount + 1 : 0} {`${ t('ROUND')} `}
            <span>
              {allChipsTotalAmount} {currencySymbolOrCode}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
